<template>
  <div style="height: 100vh;border:1px solid #fff" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div>

      <div class="search_box">
        <!-- 内容 -->
        <span @click="cleanUpEvt" class="all_text" style="margin-top:15px;">All</span>
        <div @click.stop="Filter"
          style=" line-height: 26px;margin-top:15px;  width: 80px;height: 26px;cursor: pointer;display: flex; border:1px solid #b3b7bc;margin-left:10px;justify-content: center;border-radius: 5px;margin-right: 10px;">
          <span style="font-size: 13px;color:#787373">Filter</span>
        </div>
        <div style="height:30px;margin-top:12px">

          <el-input v-if="remtInput" v-model="remtInput" style="width: 127px;" size="mini"
            placeholder="备注" @change="getList" clearable @clear="clearEvt1" :class="remtInput == '' ? 'blue' : 'orange'"
            ></el-input>

          <el-input v-if="authorIdInput" v-model="authorIdInput" style="width: 127px;" size="mini"
            placeholder="昵称" @change="getList" clearable @clear="clearEvt2"
            :class="authorIdInput == '' ? 'blue' : 'orange'" ></el-input>

          <el-input v-if="localInput" v-model="localInput" style="width: 127px;" size="mini"
            placeholder="初次登录地" @change="getList" clearable @clear="clearEvt3"
            :class="localInput == '' ? 'blue' : 'orange'" ></el-input>

          <el-date-picker v-if="value2 && value2.length" v-model="value2" style="width: 240px;"
            type="daterange" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd"
            range-separator="" @change="getList" start-placeholder="初次登录开始日期" end-placeholder="初次登录结束日期" align="right"
             :class="{ 'your-css-class': !isValue2Empty }">
          </el-date-picker>
          <el-dropdown @command="levelEvt" v-show="this.levelName !== '请选择'">
            <el-button  style="width:137px; height:28px;border:none;margin-left:3px" type="primary" size="mini" :class="levelName !== '请选择' ? 'vip-button' : 'selt'">
              {{ levelName }}<i class="el-icon-arrow-down el-icon--right"></i>
              <i class="el-icon-circle-close clear_ev" v-if="this.levelName !== '请选择'" @click="clearEvt6"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">普通账号</el-dropdown-item>
              <el-dropdown-item command="2">内部账号</el-dropdown-item>
              <el-dropdown-item command="5">客户账号</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
         
          
         
          <el-input v-model="last_login" v-if="last_login"
            style="width: 127px;padding: 1px;border-radius:5px" size="mini"
            @change="getList" placeholder="最近登录地" clearable @clear="clearEvt4"
            :class="last_login == '' ? 'blue' : 'orange'"></el-input>
         

          <el-dropdown @command="registerEvt" v-show="this.registerName !== '请选择'">
            <el-button  style="width:137px; height:28px;border:none;margin-left:3px;" type="primary" size="mini"
              :class="registerName !== '请选择' ? 'vip-button' : 'selt'">
              {{ registerName }}
              <i class="el-icon-arrow-down el-icon--right"></i>
              <i class="el-icon-circle-close  clear_ev" v-if="this.registerName" @click="clearEvt9"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">Facebook</el-dropdown-item>
              <el-dropdown-item command="2">Google</el-dropdown-item>
              <el-dropdown-item command="3">QQ</el-dropdown-item>
              <el-dropdown-item command="4">微信</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-select v-show="this.selectedType" clearable style="width: 127px;" size="mini" placeholder="请选择" @change="getList"
            :class="selectedType == '' ? 'blue' : 'orange'" v-model="selectedType">
              <!-- 下拉选项：图片和视频 -->
              <el-option label="禁用" value="1"></el-option>
              <el-option label="不禁用" value="2"></el-option>
            </el-select>

          <el-select style="width: 127px;" v-show="this.huiyuan" size="mini" placeholder="请选择" clearable
            :class="huiyuan == '' ? 'blue' : 'orange'" v-model="huiyuan" @change="getList">
            <el-option label="当前会员" value="1"></el-option>
            <el-option label="过期会员" value="2"></el-option>
            <el-option label="未充值会员" value="3"></el-option>
          </el-select>
          <el-date-picker v-model="refPicLastUseTime" v-if="refPicLastUseTime && refPicLastUseTime.length" style="width: 127px;" type="daterange" @change="getList"
            :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
            range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
            align="right" :class="{ 'your-css-class_box': refPicLastUseTime }">
          </el-date-picker>
           <el-date-picker v-model="refPicVipStartTime" v-if="refPicVipStartTime && refPicVipStartTime.length" style="width: 127px;" type="daterange" @change="getList"
              :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
              range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
              align="right" :class="{ 'your-css-class_box': refPicVipStartTime }">
            </el-date-picker>
          <el-date-picker v-model="refPicVipEndTime" v-if="refPicVipEndTime && refPicVipEndTime.length" style="width: 127px;" type="daterange" @change="getList"
            :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
            range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
            align="right" :class="{ 'your-css-class_box': refPicVipEndTime }">
          </el-date-picker>
          <el-date-picker v-model="UseTime" v-if="UseTime && UseTime.length" style="width: 127px;" type="daterange" @change="getList"
            :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
            range-separator="" class="border_box" start-placeholder="使用日期" end-placeholder="结束日期"
            align="right" :class="{ 'your-css-class_box': UseTime }">
          </el-date-picker>

          <el-select style="width: 127px;" size="mini" v-show="this.aihuiyuan" placeholder="请选择" clearable
            :class="aihuiyuan == '' ? 'blue' : 'orange'" v-model="aihuiyuan" @change="getList">
            <el-option label="当前会员" value="1"></el-option>
            <el-option label="过期会员" value="2"></el-option>
            <el-option label="未充值会员" value="3"></el-option>
          </el-select>
          <el-date-picker v-model="aiVipLastUseTime" v-if="aiVipLastUseTime && aiVipLastUseTime.length" style="width: 127px;" type="daterange" @change="getList"
            :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
            range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
            align="right" :class="{ 'your-css-class_box': aiVipLastUseTime }">
          </el-date-picker>
          <el-date-picker v-model="aiVipStartTime" v-if="aiVipStartTime && aiVipStartTime.length" style="width: 127px;" type="daterange" @change="getList"
            :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
            range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
            align="right" :class="{ 'your-css-class_box': aiVipStartTime }">
          </el-date-picker>
          <el-date-picker v-model="aiVipEndTime" v-if="aiVipEndTime && aiVipEndTime.length" style="width: 127px;" type="daterange" @change="getList"
            :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
            range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
            align="right" :class="{ 'your-css-class_box': aiVipEndTime }">
          </el-date-picker>


           <el-select style="width: 127px;" size="mini" placeholder="请选择" v-show="this.modelhuiyuan" clearable
              :class="modelhuiyuan == '' ? 'blue' : 'orange'" v-model="modelhuiyuan" @change="getList">
              <el-option label="当前会员" value="1"></el-option>
              <el-option label="过期会员" value="2"></el-option>
              <el-option label="未充值会员" value="3"></el-option>
            </el-select>
            <el-select style="width: 127px;" size="mini" placeholder="请选择" v-if="this.gongju" clearable  :class="gongju == '' ? 'blue' : 'orange'"
              v-model="gongju" @change="getList">
              <el-option label="已安装" value="已安装"></el-option>
              <el-option label="未安装" value="未安装"></el-option>
            </el-select>
            <el-date-picker v-model="modelVipLastUseTime" v-if="modelVipLastUseTime && modelVipLastUseTime.length" style="width: 127px;" type="daterange" @change="getList"
              :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
              range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
              align="right" :class="{ 'your-css-class_box': modelVipLastUseTime }">
            </el-date-picker>
            <el-date-picker v-model="modelVipStartTime" v-if="modelVipStartTime && modelVipStartTime.length" style="width: 127px;" type="daterange" @change="getList"
              :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
              range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
              align="right" :class="{ 'your-css-class_box': modelVipStartTime }">
            </el-date-picker>
            <el-date-picker v-model="modelVipEndTime" v-if="modelVipEndTime && modelVipEndTime.length" style="width: 127px;" type="daterange" @change="getList"
              :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
              range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
              align="right" :class="{ 'your-css-class_box': modelVipEndTime }">
            </el-date-picker>

             <el-select style="width: 127px;" size="mini" placeholder="请选择" v-show="this.gongjuhuiyuan"
                  :class="gongjuhuiyuan == '' ? 'blue' : 'orange'" v-model="gongjuhuiyuan" @change="getList" clearable>
                  <el-option label="当前会员" value="1"></el-option>
                  <el-option label="过期会员" value="2"></el-option>
                  <el-option label="未充值会员" value="3"></el-option>
                </el-select>
                <el-date-picker v-model="toolUseLastUseTime" v-if="toolUseLastUseTime && toolUseLastUseTime.length" style="width: 127px;" type="daterange" @change="getList"
                  :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
                  range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
                  align="right" :class="{ 'your-css-class_box': toolUseLastUseTime }">
                </el-date-picker>
                <el-date-picker v-model="toolUseVipStartTime" v-if="toolUseVipStartTime && toolUseVipStartTime.length" style="width: 127px;" type="daterange" @change="getList"
                  :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
                  range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
                  align="right" :class="{ 'your-css-class_box': toolUseVipStartTime }">
                </el-date-picker>
                <el-date-picker v-model="toolUseVipEndTime" v-if="toolUseVipEndTime && toolUseVipEndTime.length" style="width: 127px;" type="daterange" @change="getList"
                  :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
                  range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
                  align="right" :class="{ 'your-css-class_box': toolUseVipEndTime }">
                </el-date-picker>


        </div>
      </div>

      <div>
        <div
          style="border:1px solid #e5e5e5;width:100%;height: 40px;display: flex;justify-content: space-between;align-items: end;">
          <div style="width:600px;">
            <button class="tab_st" :class="{ active_load: period == 1 }" @click="setPeriod('1')"
              style="margin-left:3px;">基本信息</button>
            <button class="tab_st" :class="{ active_load: period == 2 }" @click="setPeriod('2')">参考图</button>
            <button class="tab_st" :class="{ active_load: period == 3 }" @click="setPeriod('3')">AI会员</button>
            <button class="tab_st" :class="{ active_load: period == 4 }" @click="setPeriod('4')">模型会员</button>
            <button class="tab_st" :class="{ active_load: period == 5 }" @click="setPeriod('5')">工具使用</button>

          </div>
          <div class="pagination_box">
            <el-input v-model="paginationInput" style="width: 50px" size="mini" @change="limitEvt"
              placeholder="To"></el-input>
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1"
              :page-size="paginationInput - 0" layout="prev, pager, next, jumper" :total="total" :pager-count="5"
              :show-total="showTotal">
            </el-pagination>
          </div>
        </div>
        <div style="overflow: auto;margin-top: 45px;overflow: unset">
          <el-table v-if="period == 1" class="copy" ref="sortTable" :data="tableData" :cell-style="rowStyle"
            :summary-method="getSummaries" height="55%" :empty-text="dataLoaded ? '暂无数据' : '正在加载数据中...'"
            @sort-change="sortChangeEvt" show-summary
            style="width: 100%; margin-top: 20px; overflow: none;font-size:12px">
            <!-- <el-table-column type="vlo" width="55"> </el-table-column> -->
            <el-table-column prop="" width="80" label="头像" align="center">
              <template slot-scope="props">
                <div style="display:flex;flex-direction: column;align-items: center;">
                  <el-avatar :src="props.row.header_img"></el-avatar>
                  <span style="font-size: 9px;">{{ props.row.nickname }}</span>

                </div>
              </template>
            </el-table-column>

            <el-table-column sortable="custom" prop="remark" label="备注" width="110" align="left">
              <template slot-scope="props">
                <div class="notes_box">
                  <el-input ref="editInput" v-if="props.row.id === editShowInp" v-model="props.row.remark"
                    @keyup.enter.native="determineEvt" @blur="editInpBlurEvt" placeholder="请选择内容"></el-input>
                  <div class="name_box" @click="editShowEvt(props.row, 'remark')" v-else>
                    <span style="height: 72px; line-height: 72px">{{
                      props.row.remark
                    }}</span>
                    <i class="el-icon-edit"></i>
                  </div>
                </div>
              </template>
            </el-table-column>


            <el-table-column sortable="custom" prop="level" width="85" label="等级" align="left">
              <template slot-scope="props">
                <div>
                  <el-dropdown trigger="click" @command="tableLevelEvt">
                    <span class="el-dropdown-link" @click="activeTextEvt(props.row)"
                      :style="{ color: props.row.level === '普通账号' ? '#d1d1d1' : props.row.level === '客户账号' ? '#409eff' : '#333' }">
                      {{ props.row.level }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :disabled="props.row.level == '普通账号'" command="1">普通账号</el-dropdown-item>
                      <el-dropdown-item :disabled="props.row.level == '内部账号'" command="2">内部账号</el-dropdown-item>
                      <el-dropdown-item :disabled="props.row.level == '客户账号'" command="5">客户账号</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="social_type" label="注册来源" width="95" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="total_cost" label="总消费金额" width="105" align="left">
              <template slot-scope="props">
                <common-zero-style :value="props.row.total_cost" />
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="refer_recharge" label="参考图金额" width="105" align="left">
              <template slot-scope="props">
                <common-zero-style :value="props.row.refer_recharge" />
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="ai_recharge" label="AI会员金额" width="110" align="left">
              <template slot-scope="props">
                <common-zero-style :value="props.row.ai_recharge" />
              </template>
            </el-table-column>


            <el-table-column sortable="custom" prop="model_recharge" label="模型金额" width="95" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="member" label="参考图会员" width="105" align="left">
              <template slot-scope="scope">
                    <!-- 定义映射对象，key是身份值，value包含文字和颜色 -->
                    <span :style="{ color: {1:'#000',2:'#f56c6c',3:'#c0c4cc'}[scope.row.member] || '#c0c4cc' }">
                    {{ {1:'会员中',2:'已过期',3:'非会员'}[scope.row.member] || '非会员' }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="ai_member" label="AI会员" width="90" align="left">
              <template slot-scope="scope">
                    <!-- 定义映射对象，key是身份值，value包含文字和颜色 -->
                    <span :style="{ color: {1:'#000',2:'#f56c6c',3:'#c0c4cc'}[scope.row.ai_member] || '#c0c4cc' }">
                    {{ {1:'会员中',2:'已过期',3:'非会员'}[scope.row.ai_member] || '非会员' }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="" label="模型会员" width="95" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="" label="工具使用" width="95" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="create_time" label="初次登录日期" width="120" align="left">
              <template slot-scope="props">
                <div>
                  <el-tooltip class="item" effect="dark" :content="props.row.create_time" placement="bottom">
                    <span>{{ props.row.create_time.substring(0, 11) }}</span>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="first_local" label="初次登录地" width="110" align="left">
              <template slot-scope="props">
                <div>
                  <el-tooltip class="item" effect="dark" :content="props.row.first_local" placement="bottom">
                    <span>{{ props.row.first_local.substring(0, 6) }}</span>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="update_time" label="最后使用日期" width="120" align="left">
              <template slot-scope="props">
                <div>
                  <el-tooltip class="item" effect="dark" :content="props.row.update_time" placement="bottom">
                    <span>{{ props.row.update_time.substring(0, 11) }}</span>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>

            <el-table-column sortable="custom" prop="last_local" label="最后登录地" width="110" align="left">
              <template slot-scope="props">
                <div>
                  <el-tooltip class="item" effect="dark" :content="props.row.last_local" placement="bottom">
                    <span>{{ props.row.last_local.substring(0, 6) }}</span>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column  sortable="custom" label="禁用" align="left" >
                <template #default="scope">
                  <el-switch
                    v-model="scope.row.is_active"
                    active-color="#e5e5e5"
                    inactive-color="#ff4949"
                    :active-value="'有效'"
                    :inactive-value="'无效'"
                    @change="handleSwitchChange(scope.row)"
                  />
                </template>
              </el-table-column>


          </el-table>
          <el-table v-if="period == 2" class="copy" ref="sortTable" :data="tableData" :cell-style="rowStyle"
            :summary-method="getSummaries" height="55%" :empty-text="dataLoaded ? '暂无数据' : '正在加载数据中...'"
            @sort-change="sortChangeEvt" show-summary
            style="width: 100%; margin-top: 20px; overflow: none;font-size:12px">
            <el-table-column prop="" width="80" label="头像" align="center">
              <template slot-scope="props">
                <div style="display:flex;flex-direction: column;align-items: center;">
                  <el-avatar :src="props.row.header_img"></el-avatar>
                  <span style="font-size: 9px;">{{ props.row.nickname }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="remark" label="备注" width="180" align="left">
              <template slot-scope="props">
                <div class="notes_box">
                  <el-input ref="editInput" v-if="props.row.id === editShowInp" v-model="props.row.remark"
                    @keyup.enter.native="determineEvt" @blur="editInpBlurEvt" placeholder="请选择内容"></el-input>
                  <div class="name_box" @click="editShowEvt(props.row, 'remark')" v-else>
                    <span style="height: 72px; line-height: 72px">
                      {{ props.row.remark }}</span>
                    <i class="el-icon-edit"></i>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="level" width="120" label="等级" align="left">
              <template slot-scope="props">
                <div>
                  <el-dropdown trigger="click" @command="tableLevelEvt">
                    <span class="el-dropdown-link" @click="activeTextEvt(props.row)"
                      :style="{ color: props.row.level === '普通账号' ? '#d1d1d1' : props.row.level === '客户账号' ? '#409eff' : '#333' }">
                      {{ props.row.level }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :disabled="props.row.level == '普通账号'" command="1">普通账号</el-dropdown-item>
                      <el-dropdown-item :disabled="props.row.level == '内部账号'" command="2">内部账号</el-dropdown-item>
                      <el-dropdown-item :disabled="props.row.level == '客户账号'" command="5">客户账号</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </template>
            </el-table-column>

           
            <el-table-column sortable="custom" prop="member" width="160" label="当前参考图会员情况" align="left">
              <template slot-scope="scope">
                    <!-- 定义映射对象，key是身份值，value包含文字和颜色 -->
                    <span :style="{ color: {1:'#000',2:'#f56c6c',3:'#c0c4cc'}[scope.row.member] || '#c0c4cc' }">
                    {{ {1:'会员中',2:'已过期',3:'非会员'}[scope.row.member] || '非会员' }}
                    </span>
                </template>
            </el-table-column>

            <el-table-column sortable="custom" prop="refer_recharge" width="200" label="参考图累计充值" align="left">
              <template slot-scope="props">
                <common-zero-style :value="props.row.refer_recharge" />
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="refer_tag" width="110" label="参考图标签" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="review" width="110" label="参考图查看" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="refer_download" width="110" label="参考图下载" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="refer_fav" width="110" label="参考图收藏" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="refer_search" width="190" label="参考图搜索" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="update_time" width="110" label="最后使用" align="left" label-class-name="source_ID">
              <template slot-scope="props">
                    <span style="width:70px;display:flex;text-align: left;margin-left:15px;" >{{ props.row.update_time }}</span>
                </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="vip_start" width="110" label="会员开始" align="left" label-class-name="source_ID">
              <template slot-scope="props">
                    <span style="width:70px;display:flex;text-align: left;margin-left:15px;" >{{ props.row.vip_start }}</span>
                </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="expire_time" label="会员结束" align="left" label-class-name="source_ID">
              <template slot-scope="props">
                    <span style="width:70px;display:flex;text-align: left;margin-left:15px;" >{{ props.row.expire_time }}</span>
                </template>
            </el-table-column>
          
          </el-table>
          <el-table v-if="period == 3" class="copy" ref="sortTable" :data="tableData" :cell-style="rowStyle"
            :summary-method="getSummaries" height="55%" :empty-text="dataLoaded ? '暂无数据' : '正在加载数据中...'"
            @sort-change="sortChangeEvt" show-summary
            style="width: 100%; margin-top: 20px; overflow: none;font-size:12px">
            <!-- <el-table-column type="vlo" width="55"> </el-table-column> -->
            <el-table-column prop="" width="80" label="头像" align="center">
              <template slot-scope="props">
                <div style="display:flex;flex-direction: column;align-items: center;">
                  <el-avatar :src="props.row.header_img"></el-avatar>
                  <span style="font-size: 9px;">{{ props.row.nickname }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column sortable="custom" prop="remark" label="备注" width="180" align="left">
              <template slot-scope="props">
                <div class="notes_box">
                  <el-input ref="editInput" v-if="props.row.id === editShowInp" v-model="props.row.remark"
                    @keyup.enter.native="determineEvt" @blur="editInpBlurEvt" placeholder="请选择内容"></el-input>
                  <div class="name_box" @click="editShowEvt(props.row, 'remark')" v-else>
                    <span style="height: 72px; line-height: 72px">
                      {{ props.row.remark }}</span>
                    <i class="el-icon-edit"></i>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column sortable="custom" prop="level" width="120" label="等级" align="left">
              <template slot-scope="props">
                <div>
                  <el-dropdown trigger="click" @command="tableLevelEvt">
                    <span class="el-dropdown-link" @click="activeTextEvt(props.row)"
                      :style="{ color: props.row.level === '普通账号' ? '#d1d1d1' : props.row.level === '客户账号' ? '#409eff' : '#333' }">
                      {{ props.row.level }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :disabled="props.row.level == '普通账号'" command="1">普通账号</el-dropdown-item>
                      <el-dropdown-item :disabled="props.row.level == '内部账号'" command="2">内部账号</el-dropdown-item>
                      <el-dropdown-item :disabled="props.row.level == '客户账号'" command="5">客户账号</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </template>
            </el-table-column>

            <el-table-column sortable="custom" prop="ai_member" width="140" label="当前AI会员情况" align="left">
              <template slot-scope="scope">
                    <!-- 定义映射对象，key是身份值，value包含文字和颜色 -->
                    <span :style="{ color: {1:'#000',2:'#f56c6c',3:'#c0c4cc'}[scope.row.ai_member] || '#c0c4cc' }">
                    {{ {1:'会员中',2:'已过期',3:'非会员'}[scope.row.ai_member] || '非会员' }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="ai_recharge" width="180" label="AI累计充值" align="left">
              <template slot-scope="props">
                <common-zero-style :value="props.row.ai_recharge" />
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="ai_total" width="140" label="AI累计任务数量" align="left">
              <template slot-scope="props">
                <common-zero-style :value="props.row.ai_total" />
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="ai_total_coin" width="120" label="AI使用总点数" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="used_ai_coin" width="140" label="AI收费使用点数" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="ai_coin" width="210" label="AI收费剩余点数" align="left">
            </el-table-column>

            <el-table-column sortable="custom" prop="last_ai_time" label="最近使用时间" align="left" width="120">
              <template slot-scope="props">
                <div style="display: flex;flex-direction: column;">
                  <span>{{ props.row.last_ai_day }}</span>
                  <span style="font-size:10px;text-align:left;">{{ props.row.last_ai_time }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="ai_start_day" width="120" label="会员开始" align="left">
              <template slot-scope="props">
                <div style="display: flex;flex-direction: column;">
                  <span>{{ props.row.ai_start_day }}</span>
                  <span style="font-size:10px;text-align:left;">{{ props.row.ai_start_time }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="ai_expire_day" label="会员结束" align="left">
              <template slot-scope="props">
                <div style="display: flex;flex-direction: column;">
                  <span>{{ props.row.ai_expire_day }}</span>
                  <span style="font-size:10px;text-align:left;">{{ props.row.ai_expire_time }}</span>
                </div>
              </template>
            </el-table-column>

          </el-table>
          <el-table v-if="period == 4" class="copy" ref="sortTable" :data="tableData" :cell-style="rowStyle"
            :summary-method="getSummaries" height="55%" :empty-text="dataLoaded ? '暂无数据' : '正在加载数据中...'"
            @sort-change="sortChangeEvt" show-summary
            style="width: 100%; margin-top: 20px; overflow: none;font-size:12px">
            <!-- <el-table-column type="vlo" width="55"> </el-table-column> -->
            <el-table-column prop="" width="80" label="头像" align="center">
              <template slot-scope="props">
                <div style="display:flex;flex-direction: column;align-items: center;">
                  <el-avatar :src="props.row.header_img"></el-avatar>
                  <span style="font-size: 9px;">{{ props.row.nickname }}</span>

                </div>
              </template>
            </el-table-column>

            <el-table-column sortable="custom" prop="remark" label="备注" width="180" align="left">
              <template slot-scope="props">
                <div class="notes_box">
                  <el-input ref="editInput" v-if="props.row.id === editShowInp" v-model="props.row.remark"
                    @keyup.enter.native="determineEvt" @blur="editInpBlurEvt" placeholder="请选择内容"></el-input>
                  <div class="name_box" @click="editShowEvt(props.row, 'remark')" v-else>
                    <span style="height: 72px; line-height: 72px">
                      {{ props.row.remark }}</span>
                    <i class="el-icon-edit"></i>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column sortable="custom" prop="level" width="120" label="等级" align="left">
              <template slot-scope="props">
                <div>
                  <el-dropdown trigger="click" @command="tableLevelEvt">
                    <span class="el-dropdown-link" @click="activeTextEvt(props.row)"
                      :style="{ color: props.row.level === '普通账号' ? '#d1d1d1' : props.row.level === '客户账号' ? '#409eff' : '#333' }">
                      {{ props.row.level }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :disabled="props.row.level == '普通账号'" command="1">普通账号</el-dropdown-item>
                      <el-dropdown-item :disabled="props.row.level == '内部账号'" command="2">内部账号</el-dropdown-item>
                      <el-dropdown-item :disabled="props.row.level == '客户账号'" command="5">客户账号</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </template>
            </el-table-column>

            <el-table-column sortable="custom" prop="ai_vip" width="140" label="当前模型会员情况" align="left">
              <template slot-scope="scope">
                    <!-- 定义映射对象，key是身份值，value包含文字和颜色 -->
                    <span :style="{ color: {1:'#000',2:'#f56c6c',3:'#c0c4cc'}[scope.row.ai_vip] || '#c0c4cc' }">
                    {{ {1:'会员中',2:'已过期',3:'非会员'}[scope.row.ai_vip] || '非会员' }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="" width="170" label="模型累计充值" align="left">
            </el-table-column>

            <el-table-column sortable="custom" prop="" width="120" label="模型搜索数量" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="" width="140" label="模型累计下载数量" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="" width="140" label="模型累计下载大小" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="" width="150" label="模型剩余点数" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="" width="150" label="工具安装" align="left">
            </el-table-column>

            <el-table-column sortable="custom" prop="last_ai_time" label="最近使用时间" align="left" width="120">
              <template slot-scope="props">
                <div style="display: flex;flex-direction: column;">
                  <span>{{ props.row.last_ai_day }}</span>
                  <span style="font-size:10px;text-align:left;">{{ props.row.last_ai_time }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="" width="100" label="会员开始" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="" label="会员结束" align="left">
            </el-table-column>

          </el-table>
          <el-table v-if="period == 5" class="copy" ref="sortTable" :data="tableData" :cell-style="rowStyle"
            :summary-method="getSummaries" height="55%" :empty-text="dataLoaded ? '暂无数据' : '正在加载数据中...'"
            @sort-change="sortChangeEvt" show-summary
            style="width: 100%; margin-top: 20px; overflow: none;font-size:12px">
            <!-- <el-table-column type="vlo" width="55"> </el-table-column> -->
            <el-table-column prop="" width="80" label="头像" align="center">
              <template slot-scope="props">
                <div style="display:flex;flex-direction: column;align-items: center;">
                  <el-avatar :src="props.row.header_img"></el-avatar>
                  <span style="font-size: 9px;">{{ props.row.nickname }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column sortable="custom" prop="remark" label="备注" width="160" align="left">
              <template slot-scope="props">
                <div class="notes_box">
                  <el-input ref="editInput" v-if="props.row.id === editShowInp" v-model="props.row.remark"
                    @keyup.enter.native="determineEvt" @blur="editInpBlurEvt" placeholder="请选择内容"></el-input>
                  <div class="name_box" @click="editShowEvt(props.row, 'remark')" v-else>
                    <span style="height: 72px; line-height: 72px">
                      {{ props.row.remark }}</span>
                    <i class="el-icon-edit"></i>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column sortable="custom" prop="level" width="120" label="等级" align="left">
              <template slot-scope="props">
                <div>
                  <el-dropdown trigger="click" @command="tableLevelEvt">
                    <span class="el-dropdown-link" @click="activeTextEvt(props.row)"
                      :style="{ color: props.row.level === '普通账号' ? '#d1d1d1' : props.row.level === '客户账号' ? '#409eff' : '#333' }">
                      {{ props.row.level }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :disabled="props.row.level == '普通账号'" command="1">普通账号</el-dropdown-item>
                      <el-dropdown-item :disabled="props.row.level == '内部账号'" command="2">内部账号</el-dropdown-item>
                      <el-dropdown-item :disabled="props.row.level == '客户账号'" command="5">客户账号</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </template>
            </el-table-column>

            <el-table-column sortable="custom" prop="" width="120" label="当前工具情况" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="" width="170" label="模型累计充值" align="left">
            </el-table-column>

            <el-table-column sortable="custom" prop="" width="100" label="素材总数" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="" width="100" label="收费数量" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="" width="160" label="免费数量" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="" width="110" label="素材总流量" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="" width="120" label="收费素材流量" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="" width="150" label="免费素材流量" align="left">
            </el-table-column>

            <el-table-column sortable="custom" prop="" width="110" label="初次安装" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="" width="110" label="最后使用" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="" label="使用天数" align="left">
            </el-table-column>

          </el-table>

        </div>
      </div>
      <el-dialog :visible.sync="dialogVisible_one" width="1400" custom-class="sousuo" :show-close="false">
        <div style="height:360px;">
          <span
            style="width: 69px;border: 1px solid #589ff9;height: 26px;font-size: 12px;line-height: 26px;color: #589ff9;border-radius: 3px;cursor: pointer;display: flex;justify-content: center;margin: 0px 40px 30px 80px;"
            @click="cleanUpEvt">ALL</span>
          <div style="height:300px;display:flex">
            <div>
              <div style="text-align: end; margin-right: 50px;opacity: 0;">参考图会员</div>
              <div class="all_input">
                <span>昵称</span>
                <el-input v-model="authorIdInput" style="width: 127px;" size="mini" placeholder="请选择" @change="getList"
                  clearable @clear="clearEvt2" :class="authorIdInput == '' ? 'blue' : 'orange'"
                  class="border_box"></el-input>
              </div>
              <div class="all_input">
                <span>备注</span>
                <el-input v-model="remtInput" style="width: 127px;" size="mini" placeholder="请选择" @change="getList"
                  clearable @clear="clearEvt1" :class="remtInput == '' ? 'blue' : 'orange'"
                  class="border_box"></el-input>
              </div>
              <div class="all_input">
                <span>初次登录地</span>
                <el-input v-model="localInput" style="width: 127px;" size="mini" placeholder="请选择" @change="getList"
                  clearable @clear="clearEvt3" :class="localInput == '' ? 'blue' : 'orange'"
                  class="border_box "></el-input>
              </div>
              <div class="all_input">
                <span>最近登录地</span>
                <el-input v-model="last_login"
                  style="width: 127px;border:1px solid #858585 ;padding: 1px;border-radius:5px" size="mini"
                  @change="getList" placeholder="最近登录地" clearable @clear="clearEvt4"
                  :class="last_login == '' ? 'blue' : 'orange'"></el-input>
              </div>
              <div class="all_input">
                <span>使用时间</span>
                <el-date-picker v-model="UseTime" style="width: 127px;" type="daterange" @change="getList"
                  :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
                  range-separator="" class="border_box" start-placeholder="使用日期" end-placeholder="结束日期"
                  align="right" :class="{ 'your-css-class_box': UseTime }">
                </el-date-picker>
              </div>
            </div>

            <div>
              <div style="text-align: end; margin-right: 50px;opacity: 0;">参考图会员</div>

              <div class="all_input">
                <span>初次登录</span>
                <el-date-picker v-model="value2" style="width: 127px" type="daterange" :picker-options="pickerOptions"
                  size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" range-separator="" @change="getList"
                  start-placeholder="初次登录开始日期" end-placeholder="初次登录结束日期" align="right" class="border_box"
                  :class="{ 'your-css-class': !isValue2Empty }">
                </el-date-picker>
              </div>
              
              
              <div class="all_input">
                <span>注册来源</span>
                <el-dropdown class="num_box" @command="registerEvt">
                  <el-button type="primary" size="mini" :class="registerName !== '请选择' ? 'vip-button' : 'selt'">
                    {{ registerName }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                    <i class="el-icon-circle-close  clear_ev" v-if="this.registerName !== '请选择'" @click="clearEvt9"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="1">Facebook</el-dropdown-item>
                    <el-dropdown-item command="2">Google</el-dropdown-item>
                    <el-dropdown-item command="3">QQ</el-dropdown-item>
                    <el-dropdown-item command="4">微信</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="all_input">
                <span>等级</span>
                <el-dropdown class="num_box" @command="levelEvt">
                  <el-button type="primary" size="mini" :class="levelName !== '请选择' ? 'vip-button' : 'selt'">
                    {{ levelName }}<i class="el-icon-arrow-down el-icon--right"></i>
                    <i class="el-icon-circle-close clear_ev" v-if="this.levelName !== '请选择'" @click="clearEvt6"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="1">普通账号</el-dropdown-item>
                    <el-dropdown-item command="2">内部账号</el-dropdown-item>
                    <el-dropdown-item command="5">客户账号</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              
              <div class="all_input">
                <span>禁用</span>
                <el-select style="width: 127px;" size="mini" placeholder="请选择" @change="getList" clearable
                :class="selectedType == '' ? 'blue' : 'orange'" v-model="selectedType">
                  <!-- 下拉选项：图片和视频 -->
                  <el-option label="禁用" value="1"></el-option>
                  <el-option label="不禁用" value="2"></el-option>
                </el-select>
              </div>
              
            </div>
         
            <!-- 第四列：参考图 + 日期选择器 -->
            <div>
              <div style="text-align: end; margin-right: 35px;">参考图会员</div>
              <div class="all_input">
                <span>参考图</span>
                <el-select style="width: 127px;" size="mini" placeholder="请选择" clearable
                  :class="huiyuan == '' ? 'blue' : 'orange'" v-model="huiyuan" @change="getList">
                  <el-option label="当前会员" value="1"></el-option>
                  <el-option label="过期会员" value="2"></el-option>
                  <el-option label="未充值会员" value="3"></el-option>
                </el-select>
                
              </div>
              <div class="all_input">
                <span>最后使用</span>
                <el-date-picker v-model="refPicLastUseTime" style="width: 127px;" type="daterange" @change="getList"
                  :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
                  range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
                  align="right" :class="{ 'your-css-class_box': refPicLastUseTime }">
                </el-date-picker>
              </div>

              <div class="all_input">
                <span>会员开始</span>
                <el-date-picker v-model="refPicVipStartTime" style="width: 127px;" type="daterange" @change="getList"
                  :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
                  range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
                  align="right" :class="{ 'your-css-class_box': refPicVipStartTime }">
                </el-date-picker>
                
              </div>
              <div class="all_input">
                <span>会员结束</span>
                <el-date-picker v-model="refPicVipEndTime" style="width: 127px;" type="daterange" @change="getList"
                  :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
                  range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
                  align="right" :class="{ 'your-css-class_box': refPicVipEndTime }">
                </el-date-picker>
              </div>
            </div>
            <!-- 第五列：AI会员 + 日期选择器 -->
            <div>
              <div style="text-align: end; margin-right: 50px;">AI会员</div>
              <div class="all_input">
                <span>AI会员</span>
                <el-select style="width: 127px;" size="mini" placeholder="请选择"
                  :class="aihuiyuan == '' ? 'blue' : 'orange'" v-model="aihuiyuan" @change="getList">
                  <el-option label="当前会员" value="1"></el-option>
                  <el-option label="过期会员" value="2"></el-option>
                  <el-option label="未充值会员" value="3"></el-option>
                </el-select>
              </div>
              <div class="all_input">
                <span>最后使用</span>
                
                <el-date-picker v-model="aiVipLastUseTime" style="width: 127px;" type="daterange" @change="getList"
                  :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd"
                  range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
                  align="right" :class="{ 'your-css-class_box': aiVipLastUseTime }">
                </el-date-picker>
              </div>
              <div class="all_input">
                <span>会员开始</span>
                
                <el-date-picker v-model="aiVipStartTime" style="width: 127px;" type="daterange" @change="getList"
                  :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd"
                  range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
                  align="right" :class="{ 'your-css-class_box': aiVipStartTime }">
                </el-date-picker>
              </div>
              <div class="all_input">
                <span>会员结束</span>
                
                <el-date-picker v-model="aiVipEndTime" style="width: 127px;" type="daterange" @change="getList"
                  :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd"
                  range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
                  align="right" :class="{ 'your-css-class_box': aiVipEndTime }">
                </el-date-picker>
              </div>
            </div>

            <!-- 第六列：模型会员 + 工具安装 + 日期选择器 -->
            <div>
              <div style="text-align: end; margin-right: 50px;">模型会员</div>

              <div class="all_input">
                <span>模型会员</span>
                <el-select style="width: 127px;" size="mini" placeholder="请选择" clearable
                  :class="modelhuiyuan == '' ? 'blue' : 'orange'" v-model="modelhuiyuan" @change="getList">
                  <el-option label="当前会员" value="1"></el-option>
                  <el-option label="过期会员" value="2"></el-option>
                  <el-option label="未充值会员" value="3"></el-option>
                </el-select>
              </div>
              <div class="all_input">
                <span>工具安装</span>
                
                <el-select style="width: 127px;" size="mini" clearable placeholder="请选择" :class="gongju == '' ? 'blue' : 'orange'"
                  v-model="gongju" @change="getList">
                  <el-option label="已安装" value="已安装"></el-option>
                  <el-option label="未安装" value="未安装"></el-option>
                </el-select>
              </div>
              <div class="all_input">
                <span>最后使用</span>
                
                <el-date-picker v-model="modelVipLastUseTime" style="width: 127px;" type="daterange" @change="getList"
                  :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
                  range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
                  align="right" :class="{ 'your-css-class_box': modelVipLastUseTime }">
                </el-date-picker>
              </div>
              <div class="all_input">
                <span>会员开始</span>
                
                <el-date-picker v-model="modelVipStartTime" style="width: 127px;" type="daterange" @change="getList"
                  :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
                  range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
                  align="right" :class="{ 'your-css-class_box': modelVipStartTime }">
                </el-date-picker>
              </div>
              <div class="all_input">
                <span>会员结束</span>
                
                <el-date-picker v-model="modelVipEndTime" style="width: 127px;" type="daterange" @change="getList"
                  :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
                  range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
                  align="right" :class="{ 'your-css-class_box': modelVipEndTime }">
                </el-date-picker>
              </div>
            </div>

            <!-- 第七列：工具使用 + 日期选择器 -->
            <div>
              <div style="text-align: end; margin-right: 50px;">工具会员</div>
              <div class="all_input">
                <span>工具使用</span>
                <el-select style="width: 127px;" size="mini" placeholder="请选择"
                  :class="gongjuhuiyuan == '' ? 'blue' : 'orange'" v-model="gongjuhuiyuan" @change="getList" clearable>
                  <el-option label="当前会员" value="1"></el-option>
                  <el-option label="过期会员" value="2"></el-option>
                  <el-option label="未充值会员" value="3"></el-option>
                </el-select>
              </div>
              <div class="all_input">
                <span>最后使用</span>
                
                <el-date-picker v-model="toolUseLastUseTime" style="width: 127px;" type="daterange" @change="getList"
                  :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
                  range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
                  align="right" :class="{ 'your-css-class_box': toolUseLastUseTime }">
                </el-date-picker>
              </div>
              <div class="all_input">
                <span>会员开始</span>
                
                <el-date-picker v-model="toolUseVipStartTime" style="width: 127px;" type="daterange" @change="getList"
                  :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
                  range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
                  align="right" :class="{ 'your-css-class_box': toolUseVipStartTime }">
                </el-date-picker>
              </div>
              <div class="all_input">
                <span>会员结束</span>
                
                <el-date-picker v-model="toolUseVipEndTime" style="width: 127px;" type="daterange" @change="getList"
                  :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" clearable
                  range-separator="" class="border_box" start-placeholder="会员开始日期" end-placeholder="会员结束日期"
                  align="right" :class="{ 'your-css-class_box': toolUseVipEndTime }">
                </el-date-picker>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>

      <el-dialog title="提示" :visible.sync="deleteVisible" width="30%">
        <span style="font-size: 14px">请确认是否切换账户！</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteVisible = false">否</el-button>
          <el-button type="primary" @click="confirmDelete">是</el-button>
        </span>
      </el-dialog>


    </div>

  </div>
</template>

<script>
import { getUserListApi, editListApi } from "../../../apis/user/index";
const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
export default {
  components: {
    CommonZeroStyle: {
      props: ['value'],
      template: `<span :style="{ color: value == 0 ? '#d1d1d1' : '#333' }">{{ value }}</span>`
    }
  },
  data() {
    return {
      selectedType: '',
      UseTime: '',                 // 使用
      // 第四列：参考图相关
      huiyuan: '',                 // 参考图
      refPicLastUseTime: '',       // 参考图-最后使用
      refPicVipStartTime: '',      // 参考图-会员开始
      refPicVipEndTime: '',        // 参考图-会员结束

      // 第五列：AI会员相关
      aihuiyuan: '',               // AI会员
      aiVipLastUseTime: '',        // AI会员-最后使用
      aiVipStartTime: '',          // AI会员-会员开始
      aiVipEndTime: '',            // AI会员-会员结束

      // 第六列：模型会员 + 工具安装
      modelhuiyuan: '',            // 模型会员
      gongju: '',                  // 工具安装
      modelVipLastUseTime: '',     // 模型会员-最后使用
      modelVipStartTime: '',       // 模型会员-会员开始
      modelVipEndTime: '',         // 模型会员-会员结束

      // 第七列：工具使用相关
      gongjuhuiyuan: '',           // 工具使用
      toolUseLastUseTime: '',      // 工具使用-最后使用
      toolUseVipStartTime: '',     // 工具使用-会员开始
      toolUseVipEndTime: '',       // 工具使用-会员结束

      // 日期选择器配置
      pickerOptions: {},

      // 辅助判断空值的变量（按需定义）
      isFirstLoginTimeEmpty: true,
      isVipStartTimeEmpty: true,
      isUseTimeEmpty: true,
      isRefPicTimeEmpty: true,
      isAiVipTimeEmpty: true,
      isModelVipTimeEmpty: true,
      isToolUseTimeEmpty: true,

      dialogVisible_one: false,
      header: true,
      src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
      //备注
      remtInput: "",
      authorIdInput: "",
      localInput: "",
      last_login: "",
      //分页输入框数据
      paginationInput: 96,
      currentPage1: 1,
      //分页总数据
      total: null,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const current = new Date();
              let nowDayOfWeek = current.getDay();
              if (nowDayOfWeek === 0) nowDayOfWeek = 7;
              const dayNum = 1 * 24 * 60 * 60 * 1000;
              const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
              const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "当月",
            onClick(picker) {
              const date = new Date();
              const year = date.getFullYear();
              const month = date.getMonth();
              let thisMonthStartDate = new Date(year, month, 1);
              let thisMonthEndDate = new Date(year, month + 1, 0);
              picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
            },
          },
          {
            text: "当年",
            onClick(picker) {
              var tYear = new Date().getFullYear();
              var startTime = new Date(tYear, 0, 1); //当前年第一天
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, start]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              const current = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
              let nowDayOfWeek = current.getDay();
              let diffToMonday =
                current.getDate() - nowDayOfWeek + (nowDayOfWeek === 0 ? -6 : 1);
              const firstDate = new Date(current.setDate(diffToMonday));
              const lastDate = new Date(current.setDate(diffToMonday + 6));
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              var now = new Date();
              var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
              var ed = new Date(now.getFullYear(), now.getMonth(), 0);
              picker.$emit("pick", [fd, ed]);
            },
          },
          {
            text: "去年",
            onClick(picker) {
              var tYear = new Date().getFullYear() - 1;
              var startTime = new Date(tYear, 0, 1);
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
        ],
      },
      value2: "",
      levelName: "请选择",
      adminuser: null,
      vipName: "请选择",
      effectiveName: "请选择",
      RechargeName: "请选择",
      registerName: "请选择",
      laiyuan: null,
      input: "",
      editShowInp: null,
      editName: null,
      tableData: [],
      totalRow: null,
      //排序
      order: null,
      orField: null,
      activeId: null,
      deleteVisible: false,
      showForm: false,
      data: {},
      num: null,
      count: 0,
      pagefenye: false,//点击分页 滚动条为0
      loading: false,
      isValue2Empty: true,
      isValue2Empty_box: true,
      isValue3Empty: true,
      dataLoaded: false, // 表格数据是否加载完成的状态
      c: 1,
      period: 1,
    };
  },
  created() {
     // 先加载筛选数据
    this.loadFilterDataFromStorage();
    this.loading = true;
    
    // 修复 c 的赋值逻辑
    if (this.$store.getters.location == '' || !this.$store.getters.location) {
      this.c = 1;
    } else {
      this.c = this.$store.getters.location;
    }

    // 组装请求参数
    let data = {
      orField: this.orField,
      orWhere: this.order,
      remt: this.remtInput,
      authorId: this.authorIdInput,
      local: this.localInput,
      last_login: this.last_login,
      on_time: this.value2 ? this.value2[0] : '', // 增加空值判断
      start_time: this.value2 ? this.value2[1] : '', // 增加空值判断
      adminuser: this.adminuser,
      laiyuan: this.laiyuan,
      page: this.currentPage1,
      limit: this.paginationInput,
      c: this.c,
      is_active: this.selectedType,
      UseTime: this.UseTime,
      // 第四列：参考图相关
      huiyuan: this.huiyuan,
      refPicLastUseTime: this.refPicLastUseTime,
      refPicVipStartTime: this.refPicVipStartTime,
      refPicVipEndTime: this.refPicVipEndTime,
      // 第五列：AI会员相关
      aihuiyuan: this.aihuiyuan,
      aiVipLastUseTime: this.aiVipLastUseTime,
      aiVipStartTime: this.aiVipStartTime,
      aiVipEndTime: this.aiVipEndTime,
      // 第六列：模型会员相关
      modelhuiyuan: this.modelhuiyuan,
      gongju: this.gongju,
      modelVipLastUseTime: this.modelVipLastUseTime,
      modelVipStartTime: this.modelVipStartTime,
      modelVipEndTime: this.modelVipEndTime,
      // 第七列：工具使用相关
      gongjuhuiyuan: this.gongjuhuiyuan,
      toolUseLastUseTime: this.toolUseLastUseTime,
      toolUseVipStartTime: this.toolUseVipStartTime,
      toolUseVipEndTime: this.toolUseVipEndTime,
      type: 1,
      c: this.c 
    };

    // 发起请求并完善异常处理
    getUserListApi(data)
      .then((res) => {
        this.tableData = res.data;
        this.paginationInput = res.limit;
        this.currentPage1 = res.page - 0;
        this.total = res.total;
        this.totalRow = res.totalRow;
        this.loading = false;
        console.log('请求成功：', res); // 增加成功日志
      })
      .catch((error) => {
        // 关键：添加异常捕获
        this.loading = false;
        console.error('getUserListApi 请求失败：', error); // 打印错误信息
        console.error('请求参数：', data); // 打印请求参数，方便排查
        // 可选：提示用户
        // this.$message.error('数据加载失败，请刷新重试');
      });

    // 监听键盘事件
    window.addEventListener("keydown", this.handKeyCode, true);
    window.addEventListener('keyup', this.handKeyEvt);
  },
  beforeDestroy() {
    // 在组件生命周期结束的时候销毁
    window.removeEventListener("keydown", this.handKeyCode, false);
    window.removeEventListener("keyup", this.handKeyEvt, false);
  },
  mounted() {
    //监听页面滚动条事件
    window.addEventListener("scroll", (e) => this.imgScrollEvt(e), true);
    this.c = this.$store.getters.location;
    this.loadFilterDataFromStorage()

  },

  methods: {
    handleSwitchChange(row) {
      // 将 true 映射为 1，false 映射为 2
      const status = row.is_active === '有效' ? 1 : 2;

      editListApi({
        id: row.id,
        field: "is_active",
        val: status,
      }).then((e) => {
        // 更新 tableData 中的 is_active 值为布尔值，以保持与 el-switch 的绑定一致
        this.tableData = this.tableData.map((val) => {
          if (val.id == row.id) {
            val.is_active = row.is_active;
          }
          return val;
        });
      });
    },

    loadFilterDataFromStorage() {
      try {
        const filterStr = sessionStorage.getItem('allFilterConditions')
        if (!filterStr) {
          console.log('无存储的筛选条件')
          return
        }
        const filterData = JSON.parse(filterStr)
        console.log('读取到的筛选条件：', filterData)

        // 定义所有需要赋值的字段列表
        const filterFields = [
          // 基础输入框
          'authorIdInput', 'remtInput', 'localInput', 'last_login' , 'UseTime',
          // 基础日期选择器
          'value2',
          // 下拉菜单
          'effectiveName', 'vipName', 'registerName', 'levelName', 'RechargeName',
          // 下拉选择器
          'selectedType', 'huiyuan',
          // 参考图
          'refPicLastUseTime', 'refPicVipStartTime', 'refPicVipEndTime',
          // AI会员
          'aihuiyuan', 'aiVipLastUseTime', 'aiVipStartTime', 'aiVipEndTime',
          // 模型会员
          'modelhuiyuan', 'gongju', 'modelVipLastUseTime', 'modelVipStartTime', 'modelVipEndTime',
          // 工具使用
          'gongjuhuiyuan', 'toolUseLastUseTime', 'toolUseVipStartTime', 'toolUseVipEndTime'
        ]

        // 批量赋值
        filterFields.forEach(field => {
          if (filterData[field] !== undefined) {
            this[field] = filterData[field]
          }
        })
        this.loading = false
        console.log('所有筛选条件赋值完成')
      } catch (e) {
        console.error('读取/赋值筛选条件失败：', e)
      }
    },


    Filter() {
      this.dialogVisible_one = true

      console.log(3213123);

    },
    getSubscriptionText(value) {
      switch (value) {
        case 0: return '免费版';
        case 1: return '基础版';
        case 2: return '专业版';
        case 3: return '最大额度';
      }
    },
    setPeriod(value) {
      setTimeout(() => {
        this.$nextTick(() => {
          this.period = value;
          $this.$forceUpdate()
        })
      }, 50);

    },
    //分页只显示前三页加总数
    showTotal(total) {
      return `共 ${total} 页`;
    },

    //按下键盘事件
    handKeyCode(e) {
      e = e || window.event;
      if (e.keyCode == 78) {
        // this.cleanUpEvt()
      }
      if (e.keyCode == 70) {
        this.count++;
        if (this.count == 1) {
          this.showForm = true
        } else {
          this.showForm = false
        }
        setTimeout(() => {
          this.count = 0;
        }, 500);
      }
      //Page Up 翻页
      if (e.keyCode == 34) {
        if (this.allLabel == true) {
          return;
        }
        if (
          this.dialogVisible == true ||
          this.searchLabelDialog == true ||
          this.rightLabelDialog == true ||
          this.deleteVisible == true ||
          this.uploadVisible == true
        ) {
          e.preventDefault();
          this.arrowRightEvt()
          this.inputValue_box = ''
          return;
        }
        this.loading = true
        e.preventDefault();
        delay(() => {
          this.currentPage1++;
          this.getList()
        }, 300);
      }
      // Page Down向后分页
      if (e.keyCode == 33) {
        this.loading = true
        delay(() => {
          if (this.currentPage1 <= 1) {
            this.currentPage1 = 1;
          } else {
            this.currentPage1--;
          }
          this.getList()
        }, 300);
      }
    },

    limitEvt() {
      this.getList();
    },
    //滑动事件
    imgScrollEvt(e) {
      var e =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        e ||
        document.body.scrollTop;
      //点击分页 滚动条为0
      if (this.pagefenye == true) {
        e.scrollTop = 0;
        this.pagefenye = false
        return
      }
      var scrollTop = e.target.scrollTop;
      let scrollStep = scrollTop - this.oldScrollTop;
      this.oldScrollTop = scrollTop;
      var scrollLeft = e.target.scrollLeft;
      let scrollLeftStep = scrollLeft - this.oldScrollLeft;
      this.oldScrollLeft = scrollLeft;

      if (scrollLeft > 0 && scrollTop == 0) {
        this.header = true;
        this.$store.dispatch("setShowHeader", this.header);
        return;
      }
      if (scrollTop <= 0) {
        this.header = true;
        this.$store.dispatch("setShowHeader", this.header);
        return;
      }
      if (scrollStep == 0) {
        this.header = true;
        this.$store.dispatch("setShowHeader", this.header);
        return;
      }
      if (scrollStep < 0) {
        this.header = true;
        this.$store.dispatch("setShowHeader", this.header);
      } else {
        this.header = true;
        this.$store.dispatch("setShowHeader", this.header);
      }
    },
    //分页
    handleCurrentChange(res) {
      this.loading = true
      setTimeout(() => {
        this.getList()
        this.loading = false
      }, 100)
    },
    //
    rowStyle({ row, column, rowIndex, columnIndex }) {
      if (column.label == "等级") {
        return {};
      } else if (column.label == "昵称") {
        return {};
      }
    },
    //列表排序
    sortChangeEvt(row) {
      if (row.order == "ascending") {
        this.order = "asc";
      } else if (row.order == "descending") {
        this.order = "desc";
      }
      this.orField = row.prop;
      this.getList();
    },
    //显示修改输入框
    editShowEvt(e, s) {
      console.log(e, 3213);

      this.editShowInp = e.id;
      this.editName = s;
      this.$nextTick((_) => {
        this.$refs.editInput.$refs.input.focus();
      });
    },
    determineEvt() {
      editListApi({
        id: this.editShowInp,
        field: this.editName,
        val: this.$refs.editInput.nativeInputValue,
      }).then((res) => {
        this.editShowInp = null;
      });
    },
    editInpBlurEvt() {
      editListApi({
        id: this.editShowInp,
        field: this.editName,
        val: this.$refs.editInput.nativeInputValue,
      }).then((res) => {
        this.editShowInp = null;
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        for (let key in this.totalRow) {
          if (column.property == key) {
            sums[index] = this.totalRow[key];
          }
        }
        if (index === 0) {
          sums[index] = this.total
          console.log(this.total, 321);
          return;
        }

      });
      return sums;
    },
    activeEvt(res) {
      let str = "";
      if (res == 1) {
        str = "有效";
      } else {
        str = "无效";
      }
      editListApi({
        id: this.activeId,
        field: "is_active",
        val: res,
      }).then((e) => {
        this.tableData = this.tableData.map((val) => {
          if (val.id == this.activeId) {
            val.is_active = str;
          }
          return val;
        });
      });
    },
    //等级
    tableLevelEvt(res) {
      this.num = res
      this.deleteVisible = true
    },
    confirmDelete() {
      let str = "";
      switch (this.num) {
        case "1":
          str = "普通账号";
          break;
        case "2":
          str = "内部账号";
          break;
        case "5":
          str = "客户账号";
          break;
      }
      editListApi({
        id: this.activeId,
        field: "level",
        val: this.num,
      }).then((e) => {
        this.tableData = this.tableData.map((val) => {
          if (val.id == this.activeId) {
            val.level = str;
          }
          return val;
        });
        this.deleteVisible = false
      });
    },
    activeTextEvt(res) {
      this.activeId = res.id;
    },
 
    //等级
    levelEvt(res) {
      switch (res) {
        case "1":
          this.levelName = "普通账号";
          break;
        case "2":
          this.levelName = "内部账号";
          break;
        case "5":
          this.levelName = "客户账号";
          break;
      }
      this.adminuser = res;
      this.getList();
    },
  
   
    //注册来源
    registerEvt(res) {
      switch (res) {
        case "1":
          this.registerName = "Facebook";
          break;
        case "2":
          this.registerName = "Google";
          break;
        case "3":
          this.registerName = "QQ";
          break;
        case "4":
          this.registerName = "微信";
          break;
      }
      this.laiyuan = res;
      this.getList();
    },
    //获取页面数据
    getList() {
      const allFilterData = {
        // 第一列：基础信息（命名一致，无需修改）
        authorIdInput: this.authorIdInput,
        remtInput: this.remtInput,
        localInput: this.localInput,
        last_login: this.last_login,

        // 第二列：日期选择器（修正命名，匹配模板中的 v-model）
        value2: this.value2,          // 初次登录时间（原 firstLoginTime 改为 value2）

        // 第三列：下拉选择器（命名一致，无需修改）
        effectiveName: this.effectiveName,
        vipName: this.vipName,
        registerName: this.registerName,
        levelName: this.levelName,
        RechargeName: this.RechargeName,
        selectedType: this.selectedType,

        // 第四列：参考图相关（命名一致，无需修改）
        UseTime: this.UseTime,
        huiyuan: this.huiyuan,
        refPicLastUseTime: this.refPicLastUseTime,
        refPicVipStartTime: this.refPicVipStartTime,
        refPicVipEndTime: this.refPicVipEndTime,

        // 第五列：AI会员相关（命名一致，无需修改）
        aihuiyuan: this.aihuiyuan,
        aiVipLastUseTime: this.aiVipLastUseTime,
        aiVipStartTime: this.aiVipStartTime,
        aiVipEndTime: this.aiVipEndTime,

        // 第六列：模型会员相关（命名一致，无需修改）
        modelhuiyuan: this.modelhuiyuan,
        gongju: this.gongju,
        modelVipLastUseTime: this.modelVipLastUseTime,
        modelVipStartTime: this.modelVipStartTime,
        modelVipEndTime: this.modelVipEndTime,

        // 第七列：工具使用相关（命名一致，无需修改）
        gongjuhuiyuan: this.gongjuhuiyuan,
        toolUseLastUseTime: this.toolUseLastUseTime,
        toolUseVipStartTime: this.toolUseVipStartTime,
        toolUseVipEndTime: this.toolUseVipEndTime
      }
      // 存储到sessionStorage（序列化，兼容数组/字符串类型）
      sessionStorage.setItem('allFilterConditions', JSON.stringify(allFilterData))
      // 执行你的列表查询逻辑
      console.log('当前所有筛选条件：', allFilterData)

      let data = {
        orField: this.orField,
        orWhere: this.order,
        remt: this.remtInput,
        authorId: this.authorIdInput,
        local: this.localInput,
        last_login: this.last_login,
        on_time: this.value2[0],
        start_time: this.value2[1],

        adminuser: this.adminuser,
        laiyuan: this.laiyuan,
        page: this.currentPage1,
        limit: this.paginationInput,
        c: this.c,
        is_active:this.selectedType,
        UseTime: this.UseTime,
        // 第四列：参考图相关（命名一致，无需修改）
        huiyuan: this.huiyuan,
        refPicLastUseTime: this.refPicLastUseTime,
        refPicVipStartTime: this.refPicVipStartTime,
        refPicVipEndTime: this.refPicVipEndTime,

        // 第五列：AI会员相关（命名一致，无需修改）
        aihuiyuan: this.aihuiyuan,
        aiVipLastUseTime: this.aiVipLastUseTime,
        aiVipStartTime: this.aiVipStartTime,
        aiVipEndTime: this.aiVipEndTime,

        // 第六列：模型会员相关（命名一致，无需修改）
        modelhuiyuan: this.modelhuiyuan,
        gongju: this.gongju,
        modelVipLastUseTime: this.modelVipLastUseTime,
        modelVipStartTime: this.modelVipStartTime,
        modelVipEndTime: this.modelVipEndTime,

        // 第七列：工具使用相关（命名一致，无需修改）
        gongjuhuiyuan: this.gongjuhuiyuan,
        toolUseLastUseTime: this.toolUseLastUseTime,
        toolUseVipStartTime: this.toolUseVipStartTime,
        toolUseVipEndTime: this.toolUseVipEndTime,
        type :1 
      };
      getUserListApi(data).then((res) => {
        this.tableData = res.data;
        this.paginationInput = res.limit;
        this.currentPage1 = res.page - 0;
        this.total = res.total;
        this.totalRow = res.totalRow;
        this.pagefenye = true;  //点击分页 滚动条为0
        let as = document.querySelector('.el-table__body-wrapper')
        as.scrollTop = 0
        this.imgScrollEvt(as)
        this.loading = false;
        this.dataLoaded = true; // 数据加载完成，修改dataLoaded的状态
      });

    },
    //清除搜索条件
    cleanUpEvt() {
      // 1. 清空原有基础筛选条件
      this.value2 = '';
      this.adminuser = null;
      this.laiyuan = null;
      this.currentPage1 = 1;

      this.remtInput = "";
      this.authorIdInput = "";
      this.localInput = "";
      this.last_login = ""; // 注意：原代码里是last_logi，和模板里的last_login可能是笔误，需确认
      this.levelName = "请选择";
      this.vipName = "请选择";
      this.effectiveName = "请选择";
      this.RechargeName = "请选择";
      this.registerName = "请选择";

      // 2. 清空新增的下拉选择器（参考图、AI会员等）
      this.selectedType = "";       // 禁用
      this.huiyuan = "";            // 参考图
      this.aihuiyuan = "";          // AI会员
      this.modelhuiyuan = "";       // 模型会员
      this.gongju = "";             // 工具安装
      this.gongjuhuiyuan = "";      // 工具使用

      // 3. 清空所有日期选择器（包括新增的）
      this.UseTime = "";            // 使用时间
      this.firstLoginTime = "";     // 初次登录
      this.vipStartTime = "";       // 会员开始
      this.useTime = "";            // 使用时间
      this.lastUseTime = "";        // 最后使用
      this.refPicLastUseTime = "";  // 参考图-最后使用
      this.refPicVipStartTime = ""; // 参考图-会员开始
      this.refPicVipEndTime = "";   // 参考图-会员结束
      this.aiVipLastUseTime = "";   // AI会员-最后使用
      this.aiVipStartTime = "";     // AI会员-会员开始
      this.aiVipEndTime = "";       // AI会员-会员结束
      this.modelVipLastUseTime = "";// 模型会员-最后使用
      this.modelVipStartTime = "";  // 模型会员-会员开始
      this.modelVipEndTime = "";    // 模型会员-会员结束
      this.toolUseLastUseTime = ""; // 工具使用-最后使用
      this.toolUseVipStartTime = "";// 工具使用-会员开始
      this.toolUseVipEndTime = "";  // 工具使用-会员结束

      // 4. 同步清空sessionStorage中的筛选条件
      sessionStorage.removeItem("allFilterConditions");

      this.$refs.sortTable.clearSort();
      this.orField = null;
      this.order = null;
      getUserListApi({ c: this.c ,
        type :1, }).then((res) => {
        this.tableData = res.data;
        this.paginationInput = res.limit;
        this.currentPage1 = res.page - 0;
        this.total = res.total;
        this.totalRow = res.totalRow;
        this.pagefenye = true;  //点击分页 滚动条为0
        let as = document.querySelector('.el-table__body-wrapper')
        as.scrollTop = 0
        this.imgScrollEvt(as)
        this.loading = false;
      });
    },
    OK_Pop() {
      this.getList()
      const form = document.getElementById('form');
      const closeBtn = document.getElementById('close-btn');
      closeBtn.addEventListener('click', function () {
        form.style.display = 'none';
      });
    },
    clearEvt1() {
      this.remtInput = '';
      this.clear()
    },
    clearEvt2() {
      this.authorIdInput = '';
      this.clear()
    },
    clearEvt3() {
      this.localInput;
      this.clear()
    },
    clearEvt4() {
      this.last_login = '';
      this.clear()
    },
  
    clearEvt6() {
      this.levelName = "请选择";
      this.adminuser = 0;
      this.clear()
    },
   
    clearEvt9() {
      // 1. 重置页面视图数据
      this.registerName = "请选择";
      this.laiyuan = 0;
      this.clear();

      try {
        // 2. 读取存储中的筛选条件
        const filterStr = sessionStorage.getItem('allFilterConditions');
        if (!filterStr) return;

        const filterData = JSON.parse(filterStr);
        const targetKey = 'registerName'; // 要删除的指定字段（对应截图中的Facebook）

        // 3. 精准删除目标字段并同步存储
        if (filterData.hasOwnProperty(targetKey)) {
          delete filterData[targetKey];
          // 关键：重新存入存储，覆盖旧数据
          sessionStorage.setItem('allFilterConditions', JSON.stringify(filterData));
          // 同步更新组件内的对应属性（避免页面和存储不一致）
          this[targetKey] = "请选择";
          console.log(`已成功删除存储中的【${targetKey}】字段`);
        }
      } catch (e) {
        console.error('删除存储字段失败：', e);
      }
    },
    //选中后内容点击X清除内容并刷新数据
    clear() {
      getUserListApi({ c: this.c,
        type :1,  }).then((res) => {
        this.tableData = res.data;
        this.paginationInput = res.limit;
        this.currentPage1 = res.page - 0;
        this.total = res.total;
        this.totalRow = res.totalRow;
      });
    },
  },
  //点击X后清理数据后并更改值
  computed: {
    vipNameClass() {
      if (this.vipName == '会员情况') {
        return 'red-color';
      } else {
        return '';
      }
    }
  },
  watch: {
    '$store.getters.location': function (newLocation, oldLocation) {
      this.c = newLocation
    },
    //修改选中日期的背景颜色
    'value2': function (newVal, oldVal) {
      this.isValue2Empty = !newVal;
    },
   

  }
};
</script>

<style lang="less" scoped>
@import url("../../../style/space.less");
@import url("../../../style/userList.less");

.item {
  margin-top: 10px;
}

/deep/.el-main {
  overflow: unset !important;
}

.search_box {
  height: 60px;
  border-radius: 10px;
  background-color: #fff;
  width: calc(100% - 10%);
  display: flex;

  /*visibility: hidden;*/
  .num_box {
    width: 127px;
    border: 1px solid #858585;
    border-radius: 3px;
    margin-top: 5px;
  }
}

.all_text {
  background-color: #409eff;
  font-size: 13px;
  color: #fff;
  cursor: pointer;
  height: 26px;
  border-radius: 3px;
  width: 50px;
  margin-left: 10px;
  text-align: center;
  line-height: 26px;
}


.caoz {
  margin-top: 8px;
  display: flex;
}

/* .block {
    position: absolute;
    margin-top: 9px;
    top: 0;
    right: 1%;
    transition: all 0.2s ease 0.5s;
  } */
.block {
  position: fixed;
  right: calc(100% - 99.4%);
  top: 60px;
}

.block1 {
  visibility: hidden;
}

.block1>div {
  display: none;
}

.clear {
  position: relative;
  height: 50px;

  span:nth-last-child(1) {
    background-color: #fff;
    border: 1px solid #e5e5e5;
    font-size: 13px;
    color: #c4c3c3;
    border-radius: 3px;
    position: absolute;
    right: 5px;
    bottom: -6px;
    padding: 0 10px;
    cursor: pointer;
  }

}


.demo-table-expand {
  background-color: #f2f2f2;
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  padding: 0 20px;
  width: 30%;
}

.name_box {
  display: flex;
  justify-content: left;
  align-items: center;
  width: 100%;

  i {
    cursor: pointer;
    display: none;
  }
}

.name_box:hover>i {
  display: block;
}

.pagination_box {
  min-width: 500px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.num_box button {
  width: 125px;
  border: none;
  background-color: #fff;
  color: #c4c3c3;
  height: 37px;
}



.rowClassOne {
  background-color: #e7ecff;
}

.rowClassTwo {
  color: #222222;
  background-color: #1c43ce;
}

.rowClassThree {
  background-color: #6a88f1;
}

.el-dropdown-link {
  cursor: pointer;
}

.notes_box {
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.my-icon {
  cursor: pointer;
  width: 25px;
}

/deep/.el-table thead {
  font-size: 12px;
}


/* /deep/.el-table__header-wrapper {
    background-color: #F00 !important;
    overflow-y: scroll !important;
  }
  /deep/.el-table th.el-table__cell:nth-of-type(1){
    color: #f00;
    position: fixed;
  }
  /deep/.el-table th.el-table__cell:nth-of-type(2){
    color: #f00;
  }
  /deep/.el-table th.el-table__cell:nth-of-type(3){
    color: #f00;
  }
  /deep/.el-table__fixed, .el-table__fixed-right{
    overflow-y: scroll;
  } */
/deep/.el-table__footer-wrapper {
  position: fixed;
  top: 162px;
  z-index: 111;
  background-color: #F5F7FA;
  width: calc(100% - 185px);
}

/deep/.el-table__fixed-footer-wrapper {
  display: none;
}

/deep/.el-badge__content.is-fixed {
  display: none;
}

/deep/.el-input__inner {
  color: #409eff;
  cursor: pointer;
}

.clear_ev {
  position: absolute;
  right: 10px;
}

.vip-button {
  color: #000 !important;
  background-color: #bcd9f8d4 !important;
}

.sup {
  position: absolute;
  top: -3px;
  right: -5px;
  transform: translateY(-50%) translateX(100%);
  padding: 0px 4px 0px 5px;
  background: rgb(255, 0, 0);
  border-radius: 50%;
  color: rgb(255, 255, 255);
  font-size: 12px;
  transform: scale(0.8)
}



.ellipsis {
  /* 其他样式设置 */
  cursor: pointer;
  color: blue;
}

.overflow-content {
  /* 其他样式设置 */
  display: none;
}

.overflow-content.show {
  display: block;
}

/* 朝上排序样式 */
/deep/.el-table .ascending .sort-caret.ascending {
  background-color: #f00 !important;
  background: url("../../../img/12.png")no-repeat -4px -3px !important;
  background-size: 11px 14px !important;
  width: 40px;
  height: 58px;
  z-index: 11;
}

/* 朝下排序样式 */
/deep/.el-table .descending .sort-caret.descending {
  background: url("../../../img/22.png")no-repeat -5px 2px !important;
  background-size: 11px 14px !important;
  width: 40px;
  height: 25px;

}

/deep/.el-table .descending .sort-caret.descending {
  border-top-color: #fff;
}

/* 朝上字体样式 */
/deep/.el-table__header .ascending .cell {
  color: #409EFF !important;
}

/* 朝下字体样式 */
/deep/.el-table__header .descending .cell {
  color: #409EFF !important;
}

.your-css-class {
  background-color: #bcd9f8d4 !important;
  z-index: 9999;
  border:none !important;

  input {
    background-color: #bcd9f8d4 !important;
  }
}

.your-css-class_box {
  background-color: #bcd9f8d4 !important;

  input {
    background-color: #bcd9f8d4 !important;
  }
}



/deep/.el-table__footer-wrapper .gutter {
  background: #F5F7FA;
  border-top: 1px solid #EBEEF5;
  border-bottom: 1px solid #EBEEF5;
}

//调整日期选择器的盒子大小进行修改
/deep/.el-range-editor--mini {
  height: 28px !important;
}

.tab_st {
  width: 100px;
  height: 35px;
  cursor: pointer;
  border: none;
  font-size: 12px;
  background: #F0F0F0;
}

.active_load {
  background: #fff !important;
  color: #373535;
  font-weight: 400;
  border: 1px solid #d1d1d1;
}






.all_input {
  margin-top: 10px;
  margin-left: 15px;
  display: flex;
  align-items: center;

  span {
    width: 55px;
    font-size: 11px;
    text-align: end;
    margin-right: 10px;
  }

  .el-input {
    width: 160px;
    height: 40px;
    border: 1px solid;
    border-radius: 5px;
  }

  .el-select {
    border: 1px solid;
    border-radius: 5px;
  }

  /deep/.el-input__icon {
    line-height: 30px !important;
    cursor: pointer;
  }
}

.all_input_ect {
  /deep/.el-input__icon {
    line-height: 18px !important;
    cursor: pointer;
    margin-left: -15px !important;
  }
}

/deep/.sousuo .el-input__inner {
  height: 37px !important;
  cursor: pointer;
}


/deep/ .el-input .el-input__clear:hover {
  color: #f00 !important;
}

/deep/ .el-date-editor .el-range__close-icon {
  color: #f00 !important;
}

/deep/.el-select .el-input .el-icon-circle-close {
  color: #f00 !important;
}

.sousuo .num_box {
  button {
    border: 1px solid #858585 !important;
  }
}

/deep/.sousuo {
  width: 1350px !important;
}


/deep/.el-table th.el-table__cell {
  background: #F5F7FA !important;
  padding: 0 !important;
}

/deep/.el-table__fixed-body-wrapper {
  overflow-y: scroll !important;
  height: calc(100vh - 255px) !important;
}

.el-dropdown {
  font-size: 12px !important;
}

.orange {
  /deep/.el-input__inner {
    background-color: #bcd9f8d4 !important;
    color: #222222;
    border:none !important;
  }

  /deep/.el-input__suffix {
    color: #222222;
  }
}


.num_one {
  height: 30px;
  width: 110px;
  margin-left: 5px;
  border: none;
  margin-top: 10px;
}
/deep/.source_ID{
      margin-left: 15px !important;
    }
</style>
<style>
.your-css-class .el-range-input {
  background-color: #8fc6ff00 !important;
}

.your-css-class_box .el-range-input {
  background-color: #8fc6ff00 !important;
}

.selt {
  color: #909399 !important;
}

::placeholder {
  color: #858585 !important;
}

.border_box {
  border: 1px solid #858585 !important;
  border-radius: 5px
}
</style>



// WEBPACK FOOTER //
// src/user/components/lits/index.vue